"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = exports.sizes = exports.default = exports.breakpoints = void 0;
var _styledComponents = require("styled-components");
// media.js from marketing-site

// Uses breakpoints from https://github.com/jxnblk/grid-styled#theming

const breakpoints = exports.breakpoints = ['28em', '32em', '48em', '64em'];
const sizes = exports.sizes = {
  // 0. 20em - 320px - "mobile"
  mobile: breakpoints[0],
  // 1. 28em - 448px - "phablet"
  tablet: breakpoints[1],
  // 2. 32em - 512px - "tablet"
  desktop: breakpoints[2],
  // 3. 48em - 768px - "desktop"
  giant: breakpoints[3] // 4. 64em - 1024px - "giant"
  // 5. 90em - 1440px - "beyond giant"
};
const spacing = exports.spacing = [0, 10, 15, 30, 64];

// iterate through the sizes and create a media template
var _default = exports.default = Object.keys(sizes).reduce((accumulator, label) => {
  accumulator[label] = (...args) => (0, _styledComponents.css)`
    @media (min-width: ${sizes[label]}) {
      ${(0, _styledComponents.css)(...args)}
    }
  `;
  return accumulator;
}, {});